import React from "react";

// A hook that adds a class to the <html> element.
export const useRootClass = (className: string) => {
  React.useEffect(() => {
    document.documentElement.classList.add(className);
    return () => document.documentElement.classList.remove(className);
  }, [className]);
};
